import './Breadcrumbs-dbfc9d95.css';

var classes = {"BreadcrumbsBase":"prc-Breadcrumbs-BreadcrumbsBase-6gqOz","BreadcrumbsList":"prc-Breadcrumbs-BreadcrumbsList-K7eeK","ItemSeparator":"prc-Breadcrumbs-ItemSeparator-nYObp","ItemWrapper":"prc-Breadcrumbs-ItemWrapper-Mfwuj","Item":"prc-Breadcrumbs-Item-7BKO-","BreadcrumbsItem":"prc-Breadcrumbs-BreadcrumbsItem-FHLFr","MenuOverlay":"prc-Breadcrumbs-MenuOverlay-aCOyl","MenuDetails":"prc-Breadcrumbs-MenuDetails-TXUai"};

export { classes as default };
